module.exports = __webpack_public_path__ + "img/sample15.1dd017ca.jpg";